import { ACTION_TYPES } from "./config";

export const actions = {
  set: ({ data }) => ({
    type: ACTION_TYPES.set,
    payload: {
      data,
    },
  }),
  reset: () => ({
    type: ACTION_TYPES.reset,
  }),
};
